const Tab = ({ on, children }) => (
  <span className={`px-2.5 py-1 ${on ? "text-[#1A73E8] border-b-2 border-[#1A73E8] font-semibold" : "text-[#5F6368]"}`}>{children}</span>
);

export const DevtoolsHint = () => (
  <div className="rounded-lg border border-[#D0D0D0] bg-white text-[11px] font-mono overflow-hidden select-none" data-testid="sms-devtools-hint" aria-hidden>
    <div className="flex bg-[#F1F3F4] border-b border-[#D0D0D0]">
      <Tab>Elements</Tab><Tab>Console</Tab><Tab on>Network</Tab>
    </div>
    <div className="grid grid-cols-[1fr_50px_60px] px-2.5 py-1 text-[#5F6368] border-b border-[#EEE]">
      <span>Name</span><span>Status</span><span>Type</span>
    </div>
    <div className="relative">
      <div className="grid grid-cols-[1fr_50px_60px] px-2.5 py-1 bg-[#D2E3FC] text-[#1C1C19]">
        <span className="font-semibold">config</span><span>200</span><span>document</span>
      </div>
      <div className="grid grid-cols-[1fr_50px_60px] px-2.5 py-1 text-[#9A9A90]">
        <span>m=_b,_tp</span><span>200</span><span>script</span>
      </div>
      <div className="absolute left-24 top-4 flex items-start gap-1">
        <div className="bg-white border border-[#C8C8C8] shadow-lg rounded py-1 w-24">
          <div className="px-2 py-0.5 text-[#9A9A90]">Open in tab</div>
          <div className="px-2 py-0.5 bg-[#1A73E8] text-white flex justify-between">Copy <span>▸</span></div>
        </div>
        <div className="bg-white border border-[#C8C8C8] shadow-lg rounded py-1 w-36 mt-4">
          <div className="px-2 py-0.5 text-[#9A9A90]">Copy URL</div>
          <div className="px-2 py-0.5 bg-[#1A73E8] text-white">Copy as cURL (bash)</div>
        </div>
      </div>
    </div>
    <div className="h-12" />
  </div>
);
